import React, { forwardRef } from 'react'
import Svg, { Path, SvgProps } from 'react-native-svg'

const FluentSubtractIcon = forwardRef<Svg, { fillColor?: string } & SvgProps>(
  ({ fillColor = 'currentColor', ...props }, ref) => {
    return (
      <Svg
        width={24}
        height={24}
        fill='none'
        viewBox='0 0 24 24'
        {...props}
        ref={ref}
      >
        <Path
          d='M3.75 12a.75.75 0 01.75-.75h15a.75.75 0 010 1.5h-15a.75.75 0 01-.75-.75z'
          fill={fillColor}
        />
      </Svg>
    )
  }
)

FluentSubtractIcon.displayName = 'FluentSubtractIcon'

export default FluentSubtractIcon
